"use client";
'use strict';

var React = require('react');

const FormControlContext = React.createContext({
    invalid: false,
    disabled: false,
});
const FormControlProvider = FormControlContext.Provider;

exports.FormControlContext = FormControlContext;
exports.FormControlProvider = FormControlProvider;
//# sourceMappingURL=FormControlProvider.js.map
